/**
 * Checks whether a given value is not undefined or null.
 */

export const isDefined = <T>(value?: T | null): value is T => {
  return value !== undefined && value !== null;
};
